import React, { useEffect } from 'react';
import AppLayout from '../components-app/AppLayout';
import OverviewList from '../components-static/OverviewList';
import {PageMenu,DeleteListItem,GenerateSpreadsheet,AddListItem,MobileMenu} from '../components-static/Common';
import {EditSizeLabel,EditableBox,EditableSelect,Box,Select,TextButton,Button, MultiSelect, Checkbox} from '../components-static/Input';
import u from '../utilities/Utilities';
import {BlockOptions} from '../data/Options';
import PropTypes from 'prop-types';
import {Spreadsheet} from '../data/Mimetypes';
import '../styles/staff-list.scss';
import '../styles/tenant-list.scss';
import "../styles/appointment-list.scss";
import moment from 'moment';
import { enabled } from 'store';

export default class TenantList extends React.Component{

    state={
        selected:{
            tags:[],
            all:false,
            data:[],
            entryCount:0
        },
        pageMenuButtons:[],
        spreadsheetOptions:[],
        addError:"",
        permissions:{},
        selectMode:false,
    };

    pageData={
        title:"Tenants (Company)",
        permission:"tenant",
        url:"/tenant-list",
        scrollAnchor:u.getKey(),
    };

    listData={
        deleteURL:"/api/delete-tenant-entries",
        spreadsheetURL:"/api/generate-tenant-spreadsheet",
        overviewURL:"/api/get-all-tenant",
        overviewLabel:"tenant-list",
        orderByField:"tenantName",
        orderByType:"ascending",
        numRows:20,
        checkboxPermissions:{},
        listOptions:[
            {label:"Tag Setting",ref:"macro",enabled:true,type:"list"},
        ]
    };

    componentDidMount=()=>{
        const permissions = u.getPermissions("tenant");
        this.setState({
            permissions:permissions,
            pageMenuButtons:[
                {label:"Add", mobileLabel:"Add User",ref:"add",image:"/images/page-menu/add.png",title:"Add new tenant",enabled:(permissions.create==2)},
                {label:"Template", mobileLabel:"Download Template",ref:"download",image:"/images/page-menu/template.png",title:"Download bulk add template",enabled:(permissions.create==2),onClick:this.onDownloadTemplate},
                {label:"Delete", mobileLabel:"Delete User",ref:"delete",image:"/images/page-menu/delete.png",title:"Delete selected tenant",enabled:(permissions.delete==2)},
                {label:"Spreadsheet", mobileLabel:"Generate Spreadsheet",ref:"spreadsheet",image:"/images/page-menu/spreadsheet.png",title:"Generate spreadsheet from selection",enabled:true},
            ]
        })
    };

    onMenuOptionClicked=(ref,show,mobileNav)=>{
        if(mobileNav){
            const toggle = (this.mobileSelect != ref);
            this.setState({selectMode:((ref=="spreadsheet" || ref=="delete") && toggle)});
            this.mobileSelect= ((toggle) ? ref : null);
            for(var i=0; i<mobileNav.length; i++){
                const r = mobileNav[i].ref;
                const show = (r == ref);

                if(show){
                    if(mobileNav[i].onClick){
                        mobileNav[i].onClick();
                    }
                    else if(mobileNav[i].type == "list"){
                        this.refs['overview'].triggerListOptions(r,toggle);
                    }
                    else{
                        this.refs[r].show(toggle);
                    }
                }
                else{
                    if(mobileNav[i].onClick) {

                    }
                    else if(mobileNav[i].type == "list"){
                        this.refs['overview'].triggerListOptions(r,false);
                    }
                    else{
                        this.refs[r].show(false);
                    }
                }
            }
        }
        else{
            this.setState({selectMode:((ref=="spreadsheet" || ref=="delete") && show)});
            this.refs[ref].show(show);
        }
    };

    onToggleForm=(ref,show)=>{
        this.refs['menu'].toggleForm(ref,show);
        this.mobileSelect=(show) ? ref : null;
    };

    onSelectChange=(selected)=>{
        this.setState({selected:selected});
    };

    onRefreshList=()=>{
        this.refs['overview'].onRefreshList();
    };

    onContentGrabbed=(content)=>{
        this.setState({spreadsheetOptions:content.spreadsheetOptions});
    };

    onDownloadTemplate=()=>{
        u.post({
            url:"/api/get-add-tenant-template",
            data:{},
            success:(callback)=>{
                u.download(callback.filename,callback.filestamp, ()=>{},
                (error,status)=>{
                    console.log(error);
                    this.setState({error:error});
                });
            },
            error:(error,status)=>{
                this.setState({error:error});
            }
        })
    };

    render=()=>{
        const mobileMenu = this.state.pageMenuButtons.concat(this.listData.listOptions);
        return (
            <AppLayout ref="layout" title={this.pageData.title} requiredPermission={this.pageData.permission} url={this.pageData.url}>
                <div className="page-error">{this.state.error}</div>
                <PageMenu id={this.pageData.scrollAnchor} title={this.pageData.title} ref="menu" buttons={this.state.pageMenuButtons} onMenuOptionClicked={this.onMenuOptionClicked}>
                    <AddEntry scrollAnchor={this.pageData.scrollAnchor} ref="add" reference="add" onToggleForm={this.onToggleForm} onRefreshList={this.onRefreshList}/>
                    <DeleteListItem scrollAnchor={this.pageData.scrollAnchor} ref="delete" reference="delete" url={this.listData.deleteURL} selected={this.state.selected} onToggleForm={this.onToggleForm} onRefreshList={this.onRefreshList}/>
                    <GenerateSpreadsheet scrollAnchor={this.pageData.scrollAnchor} ref="spreadsheet" url={this.listData.spreadsheetURL} options={this.state.spreadsheetOptions} reference="spreadsheet" selected={this.state.selected} onToggleForm={this.onToggleForm}/>
                </PageMenu>
                <OverviewList ref="overview" selectMode={this.state.selectMode} url={this.listData.overviewURL} label={this.listData.overviewLabel} numRows={this.listData.numRows} orderByField={this.listData.orderByField} orderByType={this.listData.orderByType} onSelectChange={this.onSelectChange} registerReference={this.registerReference} onContentGrabbed={this.onContentGrabbed} onMutatedChange={this.onMutatedChange} checkboxPermissions={this.listData.checkboxPermissions}>
                    {
                        (content,index,onChange,onContentChange,registerRef)=>{
                            return (
                                <TenantItem key={index}
                                            index={index}
                                            content={content}
                                            onChange={onChange}
                                            onContentChange={onContentChange}
                                            registerReference={registerRef}
                                            permissions={this.state.permissions}
                                            triggerPopup={this.refs['layout'].onPopup}
                                            />
                            )
                        }
                    }
                </OverviewList>
                <MobileMenu content={mobileMenu} onClick={this.onMenuOptionClicked}/>
            </AppLayout>
        )
    }
}

class TenantItem extends React.Component{

    state={
        error:""
    };

    onChangeFloors=(value)=>{

        u.post({
            url:"/api/update-tenant-info",
            data: {
                oldValue:this.props.content.floors,
                newValue:value,
                field:"floors",
                id:this.props.content.tenantID,
            },
            success:(callback)=>{
                let content = this.props.content;
                content.floors = value;
                this.props.onContentChange(content);
            },
            error:(error,status)=>{
                this.setState({error:error});
            }
        })
    }

    render=()=>{
        const content = this.props.content;
        const edit = (this.props.permissions.update == 2);
        const url = "/api/update-tenant-info";
        const index = this.props.index+""
        const id = content.tenantID;


        const isMultiBuilding = content.floors.East?.length > 0 && content.floors.West?.length > 0;
        const eastOptions = content.floors.East?.map((floor)=>({value:floor,label:`${floor}F`})) || [];
        eastOptions.sort((a,b)=>{
            const floorA = a.value;
            const floorB = b.value;
            return floorA - floorB;
        });
        eastOptions.unshift({value:"",label:"Select Floor (Optional)"});
        const westOptions = content.floors.West?.map((floor)=>({value:floor,label:`${floor}F`})) || [];
        westOptions.sort((a,b)=>{
            const floorA = a.value;
            const floorB = b.value;
            return floorA - floorB;
        });
        westOptions.unshift({value:"",label:"Select Floor (Optional)"});

        const selectedFloorOptions = content.floors.East?.concat(content.floors.West)?.map((floor)=>({value:floor,label:`${floor}F`})) || [];
        selectedFloorOptions.sort((a,b)=>{
            const floorA = a.value;
            const floorB = b.value;
            return floorA - floorB;
        });

        return (
            <div style={{textAlign:"center"}}>

                <div className="list-segment extended" style={{textAlign:"left"}}>
                    <div className="list-segment-item">
                        <div className="list-segment-label">Tenant:</div>
                        <div className="list-segment-input">
                            <EditableBox label="Tenant" field="tenantName" values={{value:content.tenantName,enabled:edit}} rules={{nullText:"None"}} index={index} id={id} url={url} onChange={this.props.onChange}/>
                        </div>
                    </div>
                    <div className="list-segment-item">
                        <div className="list-segment-label">Unit:</div>
                        <div className="list-segment-input">
                            <EditableBox label="Unit" field="unit" values={{value:content.unit,enabled:edit}} rules={{nullText:"None"}} index={index} id={id} url={url} onChange={this.props.onChange}/>
                        </div>
                    </div>
                    
                    {
                        isMultiBuilding &&
                        <div className="list-segment-item">
                            <div className="list-segment-label">Block:</div>
                            <div className="list-segment-input">
                                <EditableSelect label="Block" field="block" values={{value:content.block,enabled:edit, options: BlockOptions}} rules={{nullText:"None"}} index={index} id={id} url={url} onChange={this.props.onChange}/>
                            </div>
                        </div>
                    }
                    {
                        isMultiBuilding ?
                        <>
                        <div className="list-segment-item">
                            <div className="list-segment-label">Default Floor (East):</div>
                                <div className="list-segment-input">
                                    <EditableSelect label="Default Floor (East)"
                                                    field="defaultFloorEast"
                                                    values={{value:content.defaultFloorEast,enabled:edit,options:eastOptions}}
                                                    rules={{required:true,confirm:{title:"Confirm Default Floor Change?",description:"Changing default floor will set the default floor for all of the tenant's users",triggerPopup:this.props.triggerPopup}}}

                                                    id={id}
                                                    index={index}
                                                    url={url}
                                                    onChange={this.props.onChange}
                                                    />
                                </div>
                            </div>
                            <div className="list-segment-item">
                                <div className="list-segment-label">Default Floor (West):</div>
                                <div className="list-segment-input">
                                    <EditableSelect label="Default Floor (West)"
                                                    field="defaultFloorWest"
                                                    values={{value:content.defaultFloorWest,enabled:edit,options:westOptions}}
                                                    rules={{required:true,confirm:{title:"Confirm Default Floor Change?",description:"Changing default floor will set the default floor for all of the tenant's users",triggerPopup:this.props.triggerPopup}}}
                                                    id={id}
                                                    index={index}
                                                    url={url}
                                                    onChange={this.props.onChange}
                                                    />
                                </div>
                            </div>
                        </>
                        :
                        <div className="list-segment-item">
                            <div className="list-segment-label">Default Floor:</div>
                            <div className="list-segment-input">
                                <EditableSelect label="Default Floor"
                                                field="defaultFloor"
                                                values={{value:content.defaultFloor,enabled:edit,options:selectedFloorOptions}}
                                                rules={{required:true,confirm:{title:"Confirm Default Floor Change?",description:"Changing default floor will set the default floor for all of the tenant's users",triggerPopup:this.props.triggerPopup}}}
                                                id={id}
                                                index={index}
                                                url={url}
                                                onChange={this.props.onChange}
                                                />
                            </div>
                        </div>

                    }
                    <div className="list-segment-item">
                        <div className="list-segment-label">Status:</div>
                        <div className="list-segment-input">
                            <EditableSelect label="Status"
                                            field="status"
                                            values={{value:content.status,enabled:edit,options:[{value:"Active",label:"Active"},{value:"Inactive",label:"Inactive"}]}}
                                            rules={{required:true,confirm:{title:"Confirm Status Change?",description:"Changing tenant status will enable or disable web, app & turnstile access to all of the tenant's users",triggerPopup:this.props.triggerPopup}}}
                                            id={id}
                                            index={index}
                                            url={url}
                                            onChange={this.props.onChange}
                                            />
                        </div>
                    </div>
                </div>

                <div className="list-segment extended" style={{textAlign:"left"}}>
                    <div className="list-segment-item">
                        <div className="list-segment-label">Contact Person:</div>
                        <div className="list-segment-input">
                            <EditableBox label="Contact Person" field="contactPerson" values={{value:content.contactPerson,enabled:edit}} rules={{nullText:"None"}} index={index} id={id} url={url} onChange={this.props.onChange}/>
                        </div>
                    </div>
                    <div className="list-segment-item">
                        <div className="list-segment-label">Contact Number:</div>
                        <div className="list-segment-input">
                            <EditableBox label="Contact Number" field="contactNumber" values={{value:content.contactNumber,enabled:edit}} rules={{nullText:"None"}} index={index} id={id} url={url} onChange={this.props.onChange}/>
                        </div>
                    </div>
                    <div className="list-segment-item">
                        <div className="list-segment-label">Email:</div>
                        <div className="list-segment-input">
                            <EditableBox label="Email" field="email" type="email" values={{value:content.email,enabled:edit}} rules={{required:true,nullText:"None"}} index={index} id={id} url={url} onChange={this.props.onChange}/>
                        </div>
                    </div>
                    <div className="list-segment-item">
                        <div className="list-segment-label">Active Staff:</div>
                        <div className="list-segment-input"><EditSizeLabel>{(content.activeStaff) ? content.activeStaff : "None"}</EditSizeLabel></div>
                    </div>
                    <div className="list-segment-item">
                        <div className="list-segment-label">Total Staff:</div>
                        <div className="list-segment-input"><EditSizeLabel>{(content.totalStaff) ? content.totalStaff : "None"}</EditSizeLabel></div>
                    </div>
                </div>

                <FloorSelector building={content.block} value={content.floors || []} enabled={edit} mask={undefined} onChange={this.onChangeFloors}/>
            </div>
        )
    }
}

class AddEntry extends React.Component{

    state={
        error:"",
        entryData:{
            floors:{
                East:[],
                West:[],
            },
            block:"",
        }
    };

    addData={
        addType:0,
        addURL:"/api/add-tenant",
        bulkAddURL:"/api/add-bulk-tenant"
    };


    componentDidMount=()=>{
        this.getOptions();
    }

    show=(show)=>{
        this.refs[this.props.reference].show(show);
    }

    getOptions = () => {
        u.post({
            url:"/api/get-building-options",
            data:{},
            success:(callback)=>{
                this.setState({buildingOptions:callback.buildingOptions,buildingSettings:callback.buildingSettings});
            },
            error:(error,status)=>{
                this.setState({error:error});
            }
        })
    }

    onChangeEntry=(value,label,index,option)=>{
        let entryData=this.state.entryData;
        const prevFloors = {...entryData.floors};

        console.log("Value:",value,"Label:",label,"Index:",index,"Option:",option);

        entryData[label]=value;


        // If floors are being updated, we need to check if the tenant has access to both buildings and update default floor accordingly
        const prevHasBoth = Object.keys(prevFloors).every(block => prevFloors[block]?.length > 0);
        const newHasBoth = Object.keys(entryData.floors).every(block => entryData.floors[block]?.length > 0);

        if(label === "floors" && !prevHasBoth && newHasBoth){
            delete entryData.defaultFloor;
            entryData.block = "East";
        }else if(label === "floors" && prevHasBoth && !newHasBoth){
            entryData.defaultFloor = value[0] || "";
            delete entryData.defaultFloorEast;
            delete entryData.defaultFloorWest;
            entryData.block = Object.keys(value).find(block => value[block]?.length > 0) || "";
        }else if(label === "floors" && !newHasBoth && !prevHasBoth){
            entryData.block = Object.keys(value).find(block => value[block]?.length > 0) || "";
        }


        this.setState({entryData:entryData});
    }

    onAddEntry=()=>{
        this.setState({error:""});
        const inputs = ['tenantName','unit','email','contactNumber','contactPerson'];
        for(var i=0; i<inputs.length; i++){
            const current = this.refs[inputs[i]].validate();
            if(!current.valid){
                this.setState({error:current.value});
                return 0;
            }
        }

        // If tenant has access to both buildings, at least one default floor must be selected
        const hasBoth = Object.keys(this.state.entryData.floors).every(block => this.state.entryData.floors[block]?.length > 0);
        if(hasBoth){
            if(!this.state.entryData.defaultFloorEast && !this.state.entryData.defaultFloorWest){
                this.setState({error:"Please select a default floor for at least one of the buildings"});
                return 0;
            }
         } else if(Object.keys(this.state.entryData.floors).every(block => this.state.entryData.floors[block]?.length == 0)){
            this.setState({error:"Please select at least one floor for the tenant"});
            return 0;
        }else{
        
        }

        this.refs[this.props.reference].onValidated(this.state.entryData);
    };

    onComplete=()=>{
        this.setState({error:"",entryData:{
            floors:{East:[],West:[]},
        }});
    };



    render=()=>{
        const content=this.state.entryData;
        
        const isMultibuilding = Object.keys(content.floors).every(block => content.floors[block]?.length > 0);
        const options = {}

        const enabled = this.props.enabled ?? true;

        Object.keys(content.floors).forEach(block => {
            options[block] = content.floors[block].map(floor => ({value:floor,label:`${floor}F`}));
            options[block].unshift({value:"",label:`Select Floor (Optional)`});
            options[block].sort((a,b)=>{
                const floorA = a.value;
                const floorB = b.value;
                return floorA - floorB;
            });
        });

        const allOptions = [];

        Object.keys(content.floors).forEach(block => {
            allOptions.push(...options[block].filter(option => option.value !== ""));
        });

        const _blockOptions = [{value:"",label:"None"}].concat(BlockOptions);

        return (
            <AddListItem scrollAnchor={this.props.scrollAnchor} ref={this.props.reference}
                         reference={this.props.reference} addType={this.addData.addType}
                         index={this.addData.addIndex} label={this.addData.label} bulkURL={this.addData.bulkAddURL}
                         filetypes={Spreadsheet} url={this.addData.addURL} onToggleForm={this.props.onToggleForm}
                         onRefreshList={this.props.onRefreshList} onComplete={this.onComplete}>
                <div style={{textAlign:"center"}}>
                    <h3>Complete the following to continue</h3>
                    <div className="segment-error">{this.state.error}</div>
                    <div className="segment-content">
                        <div className="segment-margin-area">
                            <div className="segment-full-item">
                                <div className="segment-item-label">Tenant Name:</div>
                                <div className="segment-item-input">
                                    <Box ref="tenantName" label="Tenant Name" field="tenantName" values={{value:content.tenantName}} rules={{required:true}} onChange={this.onChangeEntry}/>
                                </div>
                            </div>
                            
                            <div className="segment-full-item">
                                <div className="segment-item-label">Block:</div>
                                <div className="segment-item-input">
                                    <Select ref="block" label="Block" field="block" values={{value:content.block, enabled: isMultibuilding,options:_blockOptions}} onChange={this.onChangeEntry}/>
                                </div>
                            </div>
                            {
                                !isMultibuilding ?
                                <div className="segment-full-item">
                                    <div className="segment-item-label">Default Floor:</div>
                                    <div className="segment-item-input">
                                        <Select ref="defaultFloor" label="Default Floor" field="defaultFloor" values={{value:content.defaultFloor, enabled: allOptions.length > 0,options:allOptions}} onChange={this.onChangeEntry}/>
                                    </div>
                                </div>
                            :
                            <>
                                <div className="segment-full-item">
                                    <div className="segment-item-label">Default Floor (East):</div>
                                    <div className="segment-item-input">
                                        <Select ref="defaultFloorEast" label="Default Floor (East)" field="defaultFloorEast" values={{value:content.defaultFloorEast,options:options.East}} onChange={this.onChangeEntry}/>
                                    </div>
                                </div><div className="segment-full-item">
                                    <div className="segment-item-label">Default Floor (West):</div>
                                    <div className="segment-item-input">
                                        <Select ref="defaultFloorWest" label="Default Floor (West)" field="defaultFloorWest" values={{value:content.defaultFloorWest,options:options.West}} onChange={this.onChangeEntry}/>
                                    </div>
                                </div>
                            </>
                            }
                            <div className="segment-full-item">
                                <div className="segment-item-label">Unit:</div>
                                <div className="segment-item-input">
                                    <Box ref="unit" label="Unit" field="unit" values={{value:content.unit}} rules={{required:true}} onChange={this.onChangeEntry}/>
                                </div>
                            </div>
                            <div className="segment-full-item">
                                <div className="segment-item-label">Email:</div>
                                <div className="segment-item-input">
                                    <Box ref="email" label="Email" type="email" field="email" values={{value:content.email}} rules={{placeholder:"Optional"}} onChange={this.onChangeEntry}/>
                                </div>
                            </div>
                            <div className="segment-full-item">
                                <div className="segment-item-label">Contact Number:</div>
                                <div className="segment-item-input">
                                    <Box ref="contactNumber" label="Contact Number" field="contactNumber" values={{value:content.contactNumber}} rules={{placeholder:"Optional",mobileNumber:true}} onChange={this.onChangeEntry}/>
                                </div>
                            </div>
                            <div className="segment-full-item">
                                <div className="segment-item-label">Contact Person:</div>
                                <div className="segment-item-input">
                                    <Box ref="contactPerson" label="Contact Person" field="contactPerson" values={{value:content.contactPerson}} rules={{placeholder:"Optional"}} onChange={this.onChangeEntry}/>
                                </div>
                            </div>
                        </div>

                        <span className='building-select-title'>Select floors accessible by the tenant</span>
                        <FloorSelector building={content.block} value={content.floors || []} onChange={(value) => {
                            this.onChangeEntry(value,"floors");
                        }}/>

                        <div className="segment-margin-area" style={{fontSize:"0.9em"}}>
                            <TextButton onClick={()=>{this.refs[this.props.reference].onBulkUpload()}}>Add Bulk Entries</TextButton>
                        </div>

                        <div className="segment-margin-area">
                            {
                                (u.isMobileDevice())
                                ?
                                <Button type="medium" onClick={()=>{this.props.onToggleForm(this.props.reference,false)}}>Cancel</Button>
                                :
                                ""
                            }
                            <Button type="medium" onClick={this.onAddEntry}>Add Entry</Button>
                        </div>
                    </div>
                </div>
            </AddListItem>
        )
    }
}
AddEntry.propTypes={
    scrollAnchor:PropTypes.string,
    onToggleForm:PropTypes.func.isRequired,
    onRefreshList:PropTypes.func.isRequired,
};


export class FloorSelector extends React.Component{
    state={
        buildingOptions:{},
    }

    getBuildingOptions = () => {
        u.post({
            url:"/api/get-building-options",
            data:{},
            success:(callback)=>{
                this.setState({buildingOptions:callback.buildingOptions,buildingSettings:callback.buildingSettings});
            }
        })
    }

    componentDidMount() {
        this.getBuildingOptions();
    }

    handleChange = (block, floor) => {
        
        let newFloors = this.props.value ? [...this.props.value[block]] : [];
        if(newFloors.includes(floor)){
            newFloors = newFloors.filter(f => f !== floor);
        }else{
            newFloors.push(floor);
        }
        
        const updatedFloors = {
            ...this.props.value,
            [block]: newFloors
        };

        if(Object.keys(updatedFloors).every(b => updatedFloors[b]?.length == 0)){
            this.setState({error:"At least one floor must be selected"});
            return;
        }else{
            this.setState({error:""});
        }

        this.props.onChange(updatedFloors);
    }

    validate=()=>{
        return {valid:true,value:this.props.value};
    }

    onSelectAll = (block) => {
        const allFloors = this.state.buildingOptions[block]?.map(option => option.value) || [];
        const currentFloors = this.props.value ? [...this.props.value[block]] : [];
        const allSelected = allFloors.every(floor => currentFloors.includes(floor));
        const newFloors = allSelected ? [] : allFloors;
        const updatedFloors = {
            ...this.props.value,
            [block]: newFloors
        };
        this.props.onChange(updatedFloors);
    }

    render(){
        const {buildingOptions} = this.state;
        const {mask,value,enabled} = this.props;

        return (
            <div className='segment-full-item' style={{ textAlign: "center", margin: "0 auto", display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                <span className='list-segment-error'>{this.state.error}</span>
                {
                    BlockOptions.map((building) => {
                        const maskedFilter = (mask) ? buildingOptions[building.value]?.filter(option => mask[building.value]?.includes(option.value)) : buildingOptions[building.value];
                        return (
                            <div key={building.value} style={{
                                margin: "15px auto",
                                textAlign: "center",
                              }}>
                                <div>
                                    <TextButton
                                        onClick={() => {
                                            this.onSelectAll(building.value);
                                        }}
                                        >
                                        <span className="bold">{building.label}</span>
                                        </TextButton>
                                </div>
                                <div
                                style={{
                                  display: "inline-block",
                                  margin: "10px auto",
                                }}>
                                    {
                                        (maskedFilter && maskedFilter.length > 0)
                                        ?

                                        maskedFilter.map((option) => {

                                            if(mask && !mask[building.value]?.includes(option.value)){
                                                return null;
                                            }
                                            return <div key={`${building.value}-${option.value}`} className="cargo-lift-options" onClick={()=>{
                                                this.handleChange(building.value, option.value);
                                            }}>
                                                <div>
                                                    <Checkbox key={option.value} label={option.label} values={{value:value?.[building.value].includes(option.value), enabled: enabled}} onChange={(checked) => {
                                                        this.handleChange(building.value, option.value);
                                                    }}/>
                                                </div>
                                                <span>{option.label}</span>
                                            </div>
                                        })
                                        :
                                        <p>No floor options available for the this building</p>
                                    }
                                </div>
                            </div>
                        )
                    })
                }
            </div>
        )
    }
}
